var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9375 8.5022L19.8894 8.5022M8.58814 3.2522L8.58814 19.0022M7.45801 3.2522H15.3689C16.9512 3.2522 17.7424 3.2522 18.3468 3.53831C18.8784 3.78997 19.3106 4.19155 19.5815 4.68547C19.8894 5.24699 19.8894 5.98206 19.8894 7.4522V14.8022C19.8894 16.2723 19.8894 17.0074 19.5815 17.5689C19.3106 18.0628 18.8784 18.4644 18.3468 18.7161C17.7424 19.0022 16.9512 19.0022 15.3689 19.0022H7.45801C5.87568 19.0022 5.08452 19.0022 4.48015 18.7161C3.94853 18.4644 3.51631 18.0628 3.24544 17.5689C2.9375 17.0074 2.9375 16.2723 2.9375 14.8022V7.4522C2.9375 5.98206 2.9375 5.24699 3.24544 4.68547C3.51631 4.19155 3.94853 3.78997 4.48015 3.53831C5.08452 3.2522 5.87568 3.2522 7.45801 3.2522Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIcon);
export default __webpack_public_path__ + "static/media/table-icon.364df8063cecc1e37a1d91ee7bcfd6d9.svg";
export { ForwardRef as ReactComponent };